import { extendNumericFormat } from '@ipreo/muni-shared';

export const dateFormat = 'MM/DD/YYYY';
export const amountFormat = extendNumericFormat({ style: 'decimal' });

export const ALL_ORDERS = 'orders';
export const REPORTS = 'reports';
export const MONITOR = 'monitor';
